import { BaseProduct } from '../types';

type GetMaterialTypeDayFromProducts = (products: BaseProduct[]) => string[];
type ProductHasMaterialDayOption = (product: BaseProduct) => boolean;
type GetVariantOptionKeyForMaterialTypeDay = (
  product: BaseProduct,
) => MaterialKey | null;
type ProductHasVariantWithMaterialTypeDay = (
  materialType: string,
) => (product: BaseProduct) => boolean;

type MaterialKey = 'option1' | 'option2' | 'option3';

export const getMaterialTypeDayFromProducts: GetMaterialTypeDayFromProducts = products => {
  const productsWithOption = products.filter(productHasMaterialDayOption);
  if (productsWithOption.length === 0) return [];

  const materialKey = getVariantOptionKeyForMaterialTypeDay(
    productsWithOption[0],
  );
  if (materialKey === null) return [];

  const materials = productsWithOption
    .map(product => {
      return product.variants.map(variant => variant[materialKey]);
    })
    .flat()
    .filter(material => typeof material === 'string') as string[];

  return Array.from(new Set(materials));
};

export const productHasMaterialDayOption: ProductHasMaterialDayOption = product =>
  product.options.includes('Fabric Type');

export const getVariantOptionKeyForMaterialTypeDay: GetVariantOptionKeyForMaterialTypeDay = product => {
  const materialIndex = product.options.findIndex(
    option => option === 'Fabric Type',
  );
  if (materialIndex === -1) return null;

  return `option${materialIndex + 1}` as MaterialKey;
};

export const productHasVariantWithMaterialTypeDay: ProductHasVariantWithMaterialTypeDay = materialType => product => {
  const optionKey = getVariantOptionKeyForMaterialTypeDay(product);
  if (optionKey === null) return false;

  return product.variants.some(variant => variant[optionKey] === materialType);
};
